import './index.less'

document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll(
    '.live-streaming .blocks-subscribe-banner-form'
  )

  if (forms.length > 1) {
    const secondForm = forms[1]
    if (window.innerWidth >= 1024) {
      secondForm.style.display = 'none'
    }
  }
})
